<template>
  <div class="input-group mb-3">
    <input type="text" class="form-control" :placeholder="base" @input="changeColorFromInput" v-model="inputColor"/>
    <div class="input-group-append">
      <button
        type="button"
        ref="button"
        class="btn border"
        @click="toggleModal"
        :style="`background-color: ${hex8};`"
      >
        &nbsp;
      </button>

      <Chrome
        v-model="newColor"
        class="position-absolute color-picker"
        v-if="show"
        @input="choose"
        v-closable="{
          exclude: ['button'],
          handler: 'hideModal',
        }"
      ></Chrome>
    </div>
  </div>
</template>

<script>
import { Chrome } from 'vue-color'
import _ from 'lodash'

export default {
  components: {
    Chrome,
  },
  props: ['color', 'base'],
  data() {
    return {
      inputColor: this.color || this.base || '#000000',
      newColor: this.color || this.base || '#000000',
      show: false,
    }
  },
  computed: {
    hex8() {
      return _.get(this.newColor, 'hex8') || this.color || this.base || '#000000'
    },
  },
  methods: {
    changeColorFromInput(event) {
      this.newColor = {
        hex8: event.target.value
      }
      this.$emit('input', event.target.value)
    },
    choose(color) {
      this.inputColor = color.hex8
      this.$emit('input', color.hex8)
    },
    toggleModal() {
      this.show = !this.show
    },
    showModal() {
      this.show = true
    },
    hideModal() {
      this.show = false
    },
    focusout() {
      this.hideModal()
    },
  },
}
</script>

<style>
.color-picker {
  z-index: 3;
  top:0;
  right:30px;
}
</style>
